export default __webpack_public_path__ + "static/media/Gemi_Cerceve_Bg_3.b61ded1e.png";